import React from 'react';
import './expenses.css'; // Custom CSS

const ExpenseCard = ({ budget, expenses }) => {
  const total = expenses.reduce((sum, item) => sum + item.amount, 0);

  return (
    <div className="card expense-card text-white shadow-lg p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="chip"></div>
        <small className="text-light opacity-50">Wedstra</small>
      </div>
      <div>
        <small className="text-light opacity-50">Total Budget</small>
        <h4 className="fw-bold mt-1">₹{budget?.toFixed(2)}</h4>
      </div>
      <div className="mt-4 d-flex justify-content-between align-items-center">
        <div>
          <small className="text-light opacity-50">Total Expenses</small>
          <h5 className="text-danger mt-1 fw-semibold">₹{total?.toFixed(2)}</h5>
        </div>
        <small className="text-light opacity-25">**** **** **** 1234</small>
      </div>
    </div>
  );
};

export default ExpenseCard;
